import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { EOLProducts } from "@WhiteCap/Store/Data/PromotionState";
import { CustomApiHandler } from "@WhiteCapInternal/Store/CustomHandlerCreator/CustomHandlerCreator";

type Parameter = {
    eolProducts: EOLProducts; 
};

type HandlerType = CustomApiHandler<Parameter>;

export const EOLPromotionLoadedCompleted: HandlerType = async props => {
    props.dispatch({
        type: "Custom/Promotion/EOLLoadProducts",
        eolProducts: props.parameter.eolProducts,
    });
};

export const chain = [EOLPromotionLoadedCompleted];

const eolPromotionHandler = createHandlerChainRunner(chain, "EOLPromotionHandler");
export default eolPromotionHandler;
